import React, { useState, useEffect } from "react";
import "./TranslatorHubHeader.css";
import { Link } from "gatsby";
import TomedesLogo from "assets/images/Tomedes_Logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Header from "components/layout/header";

function TranslatorHeader({ title, styleOne, show }) {
  const [hamburger, setHamburger] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const listenToScroll = () => {
    let heightToHideFrom = 60;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      isVisible && setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const removeShadow = {
    "-webkit-tap-highlight-color": "transparent",
  };

  return (
    <>
      {styleOne == 1 ? (
        <Header />
      ) : (
        // <>
        //   <div
        //     className={`w-full bg-black hidden md:block z-[100] fixed  inset-x-0`}
        //   >
        //     <div className="h-[105px] max-w-[73rem] mx-auto flex justify-between items-center px-10">
        //       <Link to="/">
        //         <img
        //           src={TomedesLogo}
        //           alt="Tomedes logo"
        //           className="translator-logo"
        //         />
        //       </Link>
        //       <div className="grid items-center font-opensans text-14 text-white">
        //         <button className="bg-yellow h-10 w-[153px] rounded-full font-bold">
        //           <Link to="/contactus.php">CONTACT US</Link>
        //         </button>
        //       </div>
        //     </div>
        //   </div>
        //   <section
        //     className={`md:hidden header-wrapper sticky ${
        //       show ? "top-[56px] md:top-[35px]" : "top-0"
        //     } left-0 right-0 z-[100] bg-black flex flex-col items-center justify-center px-4`}
        //   >
        //     <div className="flex items-center justify-between lg:flex-row flex-col py-5 sm:py-6 sm:p-6 lg:p-0  max-w-screen-xl w-full">
        //       <div className="logo flex justify-between items-center w-full text-left">
        //         {isVisible && (
        //           <Link to="/" className="md:hidden">
        //             <img
        //               src={TomedesLogo}
        //               alt="loading..."
        //               className="w-[150px] md:w-[unset] h-8"
        //             />
        //           </Link>
        //         )}
        //         {!isVisible && (
        //           <Link
        //             to="/contactus.php"
        //             className="uppercase rounded-full bg-orange hover:bg-[#ff9a16] text-white cursor-pointer text-14 font-semibold py-1 px-4 text-center transition-all duration-300 md:hidden h-8 flex items-center"
        //           >
        //             CONTACT US
        //           </Link>
        //         )}
        //         {hamburger ? (
        //           <div
        //             className="w-8 md:hidden h-8 bg-white text-black text-center flex items-center justify-center text-xl rounded-full"
        //             onClick={() => setHamburger(!hamburger)}
        //           >
        //             <FontAwesomeIcon icon={faTimes} className="" />
        //           </div>
        //         ) : (
        //           <div
        //             className="md:hidden flex flex-col items-center justify-center"
        //             onClick={() => setHamburger(!hamburger)}
        //           >
        //             <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
        //             <span className="inline-block h-1.5  w-10 my-1.5 rounded-lg bg-white"></span>
        //             <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
        //           </div>
        //         )}
        //       </div>
        //       <p className="flex md:hidden p-3 pl-0 pb-0 flex-col flex-wrap font-opensans font-normal text-[12px] leading-[20px] text-[#A5A5A5] self-baseline mt-2">
        //         <a href="mailto:support@tomedes.com">support@tomedes.com</a>
        //         <div>
        //           <a href="tel:+19852390142">US: +1 985 239 0142</a>
        //           <span>&nbsp;|&nbsp;</span>
        //           <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
        //         </div>
        //       </p>
        //     </div>
        //   </section>
        //   <section
        //     className={`${hamburger ? "block" : "hidden"} w-full lg:block`}
        //   >
        //     <nav className="lg:flex bg-black items-center justify-center relative">
        //       <ul
        //         className="nav font-normal flex items-center font-opensans lg:flex-row flex-col  text-white"
        //         style={removeShadow}
        //       >
        //         {/* <li className="leading-[19px]">
        //           <Link to="/" className="lg:px-6 lg:py-3 p-3 mx-1 text-[16px] hover:text-orange w-full cursor-pointer">
        //               <span>Home</span>
        //             </Link>
        //           </li> */}
        //       </ul>

        //       <ul className="mt-10 lg:hidden flex flex-col gap-6 md:items-center px-5">
        //         <li>
        //           <Link
        //             to="/contactus.php"
        //             className="block bg-yellow md:inline-block md:w-[450px]  uppercase rounded-full border-white font-opensans font-semibold text-gray cursor-pointer text-[14px] text-center py-5 "
        //           >
        //             CONTACT US
        //           </Link>
        //         </li>

        //         {/* <li>
        //           <Link
        //             to="/user/login"
        //             className="block md:inline-block md:w-[450px]  uppercase rounded-full border-2 border-white font-opensans font-semibold text-gray cursor-pointer text-[14px] text-center py-5"
        //           >
        //             Account
        //           </Link>
        //         </li> */}
        //       </ul>
        //       <div className="block lg:hidden">
        //         <p className="mt-8 font-secondary text-[14px] text-gray flex justify-center items-center gap-2 cursor-pointer">
        //           {/* <img src={usaSvg} alt="" /> <span>USA - EN</span> <span>{caretDownFil}</span> */}
        //         </p>
        //       </div>
        //     </nav>
        //   </section>
        // </>
        <>
          <div className="w-full bg-[#585858]">
            <header className="translator-header translator-header_desktop w-full max-w-7xl mx-auto">
              <nav
                className="translator-nav"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Link to="/quote" className="translator-btn_signin">
                  SIGN IN
                </Link>
                <Link to="/contactus.php">CONTACT US</Link>
                <Link to="/contactus.php">LIVE HELP</Link>
              </nav>
              <div>
                <Link to="/">
                  <img
                    src={TomedesLogo}
                    alt="Tomedes logo"
                    className="translator-logo"
                  />
                </Link>
              </div>
              <div>
                <h4 className="translator-h4">{title}</h4>
              </div>
            </header>
          </div>
          <header
            className="translator-header_mobile md:hidden flex items-center justify-between h-[50px] "
            style={{ paddingBottom: "0" }}
          >
            <Link to="/">
              <img
                src={TomedesLogo}
                alt="Tomedes logo"
                className="translator-logo"
              />
            </Link>
            <div
              className="translator-hamburger"
              onClick={() => document.body.classList.toggle("open")}
            >
              <span className="translator-hamburger_top"></span>
              <span className="translator-hamburger_middle"></span>
              <span className="translator-hamburger_bottom"></span>
            </div>
            <nav className="translator-mobile_nav text-white">
              <Link to="/contactus.php">CONTACT US</Link>
              <Link to="/contactus.php">LIVE HELP</Link>
              <Link to="/quote" className="translator-btn_signin">
                Sign In
              </Link>
              <select
                id="globe-lang"
                style={{ color: "#000" }}
                onChange={(e) => window.open(e.target.value, "_blank")}
              >
                <option selected>SELECT LANGUAGE</option>
                <option value="https://www.tomedes.com/">English</option>
                <option value="https://es.tomedes.com/">Español</option>
                <option value="https://cn.tomedes.com/">简体中文</option>
                <option value="https://tw.tomedes.com/">中國傳統的</option>
                <option value="https://de.tomedes.com/">Deutsch</option>
                <option value="https://fr.tomedes.com/">Français</option>
                <option value="https://nl.tomedes.com/">Nederlands</option>
                <option value="https://www.tomedes.co.il/">עברית</option>
                <option value="https://jp.tomedes.com/">日本語</option>
                <option value="https://kr.tomedes.com/">한국어</option>
                <option value="https://no.tomedes.com/">Norsk</option>
                <option value="https://pl.tomedes.com/">Polski</option>
                <option value="https://ro.tomedes.com/">Româna</option>
                <option value="https://sv.tomedes.com/">Svenska</option>
                <option value="https://tr.tomedes.com/">Türk</option>
                <option value="https://ru.tomedes.com/">Русский</option>
              </select>
            </nav>
          </header>
        </>
      )}
    </>
  );
}

export default TranslatorHeader;
